import React from 'react';

interface ViewSwitcherProps {
  activeTab: 'tree' | 'planning';
  onTabChange: (tab: 'tree' | 'planning') => void;
  className?: string;
}

export const ViewSwitcher = React.memo(
  function ViewSwitcher({ activeTab, onTabChange, className = '' }: ViewSwitcherProps) {
    return (
      <div className={`flex items-center gap-3 ${className}`}>
        <span className="text-xs text-gray-400">Switch View to:</span>

        <div className="flex items-center gap-2">
          <button
            onClick={() => onTabChange('tree')}
            className={`text-sm font-medium transition-colors duration-200 ${
              activeTab === 'tree'
                ? 'text-[#06b6d4] hover:text-[#4f46e5]'
                : 'text-gray-400 hover:text-gray-300'
            }`}
          >
            Game Tree
          </button>

          <span className="text-gray-600">|</span>

          <button
            onClick={() => onTabChange('planning')}
            className={`text-sm font-medium transition-colors duration-200 ${
              activeTab === 'planning'
                ? 'text-[#06b6d4] hover:text-[#4f46e5]'
                : 'text-gray-400 hover:text-gray-300'
            }`}
          >
            Planning Notes
          </button>
        </div>
      </div>
    );
  },
  (prevProps, nextProps) => {
    // Only re-render if activeTab changes
    return prevProps.activeTab === nextProps.activeTab;
  }
);
